import { GetAllFilesAndFoldersByUserDto } from "../types/FolderPermission";
import { FileRecycleRequestDto, GetAllDeletedItemsRequestDto, RecycleRequestDto } from "../types/Recycle";
import apiClient from "../utils/apiClient";

export const getAllDeletedItemsByUser = async (requestData?: GetAllDeletedItemsRequestDto): Promise<GetAllFilesAndFoldersByUserDto[]> => {
    const response = await apiClient.post<GetAllFilesAndFoldersByUserDto[]>('portal/recycle/deleted-items', requestData);
    return response.data;
};

export const getExistingFolderFiles = async (requestData?: RecycleRequestDto): Promise<string[]> => {
  const response = await apiClient.post<string[]>('portal/recycle/existing-items', requestData);
  return response.data;
};

export const getExistingFile = async (requestData?: FileRecycleRequestDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>('portal/recycle/existing-file', requestData);
  return response.data;
};


export const restore = async (requestData?: RecycleRequestDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>('portal/recycle/restore', requestData);
  return response.data;
};

export const fileRestore = async (requestData?: FileRecycleRequestDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>('portal/recycle/file-restore', requestData);
  return response.data;
};